<template>
    <div class="props-group rc-report">
        <el-form-item label="数据来源" prop="properties.report.sourceTableId" :rules="rules">
          <public-combobox
            v-model="component.properties.report.sourceTableId"
            :options="dataSourceReports"
            @change="changeDataSource">
          </public-combobox>
        </el-form-item>
      <el-form-item v-for="filter in filters" :label="filter.name" :key='filter.columnId'>
        <div class="formula" v-html="expressionShow(filter.reportExpression)" @click="focus(filter)"></div>
      </el-form-item>
      <el-form-item label="默认行数">
        <el-input v-model.number="component.properties.report.defaultRows" @change="changeValue" min="1"></el-input>
      </el-form-item>
    </div>
</template>

<script>
import publicCombobox from '@/components/public/public-combobox.vue'
import { calculateMixin } from '../components/mixins'

export default {
  name: 'attr-report',
  props: ['component'],
  inject: ['formService'],
  mixins: [calculateMixin],
  data () {
    return {
      rules: [
        { required: true, message: '请选择数据来源', trigger: 'blur' }
      ],
      filters: []
    }
  },
  components: {
    publicCombobox
  },
  mounted () {
    if (this.component.properties.report.sourceTableId) {
      this.loadTableColumns(this.component.properties.report.sourceTableId)
    }
  },
  computed: {
    dataSourceReports () {
      return this.formService.options.dataSourceReports
    }
  },
  methods: {
    changeValue (value) {
      let number = this.toNumber(value)
      if (isNaN(number) || number < 1) {
        number = 1
      }
      this.component.properties.report.defaultRows = Math.floor(number) // 去除小数,向下舍入
    },
    toNumber (value) {
      if (value === '' || value === undefined || typeof value === 'number' || value === null) {
        return value
      }
      let dot = value.replace(/[^.]/g, '').length
      let result = value.replace(/[^\-\d.]/g, '')
      // 若存在两个小数点再处理
      if (dot > 1) {
        result = result.replace(/(\.[^.]*)./, '$1')
      }
      return result
    },
    changeDataSource (val) {
      // 清空筛选项
      this.component.properties.report.filters = null
      this.loadTableColumns(val)
    },
    loadTableColumns (val) {
      this.filters = []
      let dataSourceReport = {}
      if (val) {
        this.formService.loadDataReport(val).then(() => {
          dataSourceReport = this.formService.options.dataSourceReports.find(m => m.id === val)
          // 只取出需要的字段
          dataSourceReport.filters.forEach(m => {
            if (m.filterType !== 'senior') {
              if (this.component.properties.report.filters) {
                m.reportExpression = this.component.properties.report.filters[m.id]
              }
              this.filters.push(this.$_.pick(m, ['id', 'name', 'columnId', 'reportExpression']))
            }
          })
        })
      }
    },
    focus (filter) {
      // 改弹窗参照 element this.$message 改造而来, 涉及 ui 方面的可直接参考 element 进行修改
      this.$Popup.calculation({
        parameter: {
          expression: filter.reportExpression,
          dataSource: this.getDataSource,
          currentColumnId: this.component.archive.columnId,
          dataSourceEnable: true,
          dataSourceReports: this.formService.options.dataSourceReports
        },
        width: '1000px'
      }).then((data) => {
        // action 两种 confirm 表示点击的是确认, cancel 表示取消
        if (data.action === 'confirm') {
          this.getExpression(data.value, filter)
          this.$set(filter, 'reportExpression', data.value)
        }
      })
    },
    getExpression (expression, filter) {
      if (!this.component.properties.report.filters) {
        this.component.properties.report.filters = {}
      }
      this.component.properties.report.filters[filter.id] = expression
    },
    expressionShow (reportExpression) {
      if (reportExpression) {
        return this.expressionToWithCode(reportExpression)
      }
    }
  }
}
</script>
<style lang="scss">
  .props-group.rc-report{
    .formula {
      position: absolute;
      margin-top: -14px;
      padding: 0 10px;
      top: 50%;
      outline: none;
      border: 1px solid #e4e7ed;
      background: #fff;
      border-radius: 4px;
      max-height: 80px;
      overflow: hidden;
      width: 100%;
      height: 28px;
      line-height: 28px;

      code {
        padding: 2px 4px;
        font-size: 90%;
        color: #c7254e;
        background-color: #f9f2f4;
        border-radius: 4px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/report.vue